//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  name: 'PtSidebarV1',
  props: {
    overlay: {
      type: Boolean,
      default: false,
    },
    partialCollapse: {
      type: Boolean,
      default: false,
    },
    position: {
      type: String,
      default: 'left',
      description: 'Sidebar position (left/right)',
    },
    width: {
      type: Number,
      default: 300,
    },
    closeOnOutsideClick: {
      type: Boolean,
      default: true,
      description: 'Whether sidebar should be close or not',
    },
  },
  data: function data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    getClasses: function getClasses() {
      var obj;

      return ( obj = {
        'pt-sidebar-v1': true
      }, obj[("pt-sidebar-v1-" + (this.position))] = true, obj[("pt-sidebar-v1-" + (this.width))] = true, obj['pt-sidebar-v1-partial-collapse'] =  this.partialCollapse, obj );
    },
  },
  watch: {
    isVisible: function isVisible(value) {
      if (this.overlay) {
        // Hide scroll when overlay is shown
        document.body.style.overflow = value ? 'hidden' : 'auto';
      }
    },
  },
  mounted: function mounted() {
    console.warn('SidebarV1 is deprecated and will be removed soon, please use the new Sidebar component');
  },
  beforeDestroy: function beforeDestroy() {
    if (this.overlay) {
      // Set overflow back to auto
      document.body.style.overflow = 'auto';
    }
  },
  methods: {
    hide: function hide() {
      this.isVisible = false;
    },
    show: function show() {
      this.isVisible = true;
    },
    toggle: function toggle() {
      this.isVisible = !this.isVisible;
    },
    handleOutsideClick: function handleOutsideClick() {
      if (!this.closeOnOutsideClick) { return; }
      this.hide();
    },
  },
};

function normalizeComponent(compiledTemplate, injectStyle, defaultExport, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, isShadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof isShadowMode === 'function') {
        createInjectorSSR = createInjector;
        createInjector = isShadowMode;
        isShadowMode = false;
    }
    // Vue.extend constructor export interop
    const options = typeof defaultExport === 'function' ? defaultExport.options : defaultExport;
    // render functions
    if (compiledTemplate && compiledTemplate.render) {
        options.render = compiledTemplate.render;
        options.staticRenderFns = compiledTemplate.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (injectStyle) {
                injectStyle.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (injectStyle) {
        hook = isShadowMode
            ? function () {
                injectStyle.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
            }
            : function (context) {
                injectStyle.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return defaultExport;
}

/* script */
            var __vue_script__ = script;
            
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", { attrs: { name: "pt-sidebar-v1" } }, [
    _vm.isVisible
      ? _c("div", [
          _c("div", { class: _vm.getClasses }, [_vm._t("default")], 2),
          _vm._v(" "),
          _vm.overlay
            ? _c("div", {
                staticClass: "pt-sidebar-v1-overlay",
                on: { click: _vm.handleOutsideClick }
              })
            : _vm._e()
        ])
      : _vm._e()
  ])
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = undefined;
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var Sidebar = normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//

var script$1 = {
  name: 'PtCollapsibleSidebar',
  components: {
    Sidebar: Sidebar,
  },
  props: {
    partialCollapse: {
      type: Boolean,
      default: false,
      description: 'Whether sidebar is partially collapsible or not',
    },
    position: {
      type: String,
      default: 'left',
      description: 'Sidebar position (left/right)',
    },
    overlay: {
      type: Boolean,
      default: false,
    },
    width: {
      type: Number,
      default: 300,
      description: 'Width of the sidebar (250/280/300/320/350)',
    },
    closeOnOutsideClick: {
      type: Boolean,
      default: true,
      description: 'Whether sidebar should be close or not',
    },
  },
  methods: {
    hide: function hide() {
      this.$refs.sidebar.hide();
    },
    show: function show() {
      this.$refs.sidebar.show();
    },
    toggle: function toggle() {
      this.$refs.sidebar.toggle();
    },
  },
};

/* script */
            var __vue_script__$1 = script$1;
            
/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    [
      _vm.partialCollapse
        ? _c(
            "div",
            {
              class: [
                "pt-collapsible-sidebar-v1",
                "pt-collapsible-sidebar-v1-" + _vm.position
              ]
            },
            [_vm._t("collapsed")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "sidebar",
        {
          ref: "sidebar",
          attrs: {
            "partial-collapse": _vm.partialCollapse,
            position: _vm.position,
            overlay: _vm.overlay,
            width: _vm.width,
            "close-on-outside-click": _vm.closeOnOutsideClick
          }
        },
        [_vm._t("expanded")],
        2
      )
    ],
    1
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  var __vue_inject_styles__$1 = undefined;
  /* scoped */
  var __vue_scope_id__$1 = undefined;
  /* module identifier */
  var __vue_module_identifier__$1 = undefined;
  /* functional template */
  var __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var CollapsibleSidebar = normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

export { CollapsibleSidebar as PtCollapsibleSidebar };
